import { Alert, Box, CircularProgress } from '@mui/material';
import { useQuery } from 'react-query';
import { PanelLogin } from 'src/components/PanelLogin';
import { useAuthContext } from 'src/context/AuthContextProvider';
import { getDebenturesLiabilityData } from 'src/services/operation/operationDebentures';

import OperationDebenturesLiabilityData from './OperationDebenturesLiabilityData';
import OperationDebenturesLiabilityQuotes from './OperationDebenturesLiabilityQuotes';

interface OperationDebenturesLiabilityProps {
  hashId: string;
}

export default function OperationDebenturesLiability({
  hashId,
}: OperationDebenturesLiabilityProps) {
  const { auth } = useAuthContext();

  const canViewLiability = Boolean(
    auth?.user?.subscription?.plan?.permissions?.operacoes_debentures_passivo,
  );

  const { data, isError, isLoading } = useQuery({
    queryKey: ['debenturesLiability', hashId],
    queryFn: () => getDebenturesLiabilityData(hashId),
    enabled: !!hashId && canViewLiability,
    retry: false,
  });

  if (!canViewLiability) {
    return (
      <Box p={2}>
        <PanelLogin />
      </Box>
    );
  }

  if (isLoading) {
    return (
      <Box p={2}>
        <CircularProgress color="primary" />
      </Box>
    );
  }

  if (isError) {
    return (
      <Box p={2}>
        <Alert severity="warning">
          Não foi possível carregar os dados de passivo desta debênture.
        </Alert>
      </Box>
    );
  }

  return (
    <Box p={2}>
      <OperationDebenturesLiabilityData
        competencia={data?.competencia ?? null}
        categories={data?.categories ?? []}
      />
      <OperationDebenturesLiabilityQuotes series={data?.series ?? []} />
    </Box>
  );
}
